import React from 'react'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'

const QuestionCopyPreviewModal = ({
  showModal,
  setShowModal,
  onConfirm,
  onCancel,
  questions = [],
  selectedQuest = null,
  isLoading = false,
  onClear,
}) => {
  const handleCancel = () => {
    if (onCancel) {
      onCancel()
    } else {
      setShowModal(false)
    }
    if (onClear) {
      onClear()
    }
  }

  const handleConfirm = () => {
    onConfirm()
    setShowModal(false)
    if (onClear) {
      onClear()
    }
  }

  const sourceLabel = selectedQuest?.label || selectedQuest?.title || ''
  const hasQuestions = Array.isArray(questions) && questions.length > 0

  return (
    <Modal
      show={showModal}
      onHide={handleCancel}
      centered
      scrollable
      backdrop={isLoading ? 'static' : true}
      keyboard={!isLoading}
      dialogClassName='experience-qcopy-dialog'
      contentClassName='experience-qcopy-card'>
      <Modal.Header className='experience-qcopy-header'>
        <h2 className='mb-0'>Enrollment form preview</h2>
      </Modal.Header>
      <Modal.Body className='experience-qcopy-body'>
        <div className='experience-qcopy-note'>
          <p>
            <strong>Note:</strong> Once you copy these questions, they will be
            added to your current form. You can edit them after copying.
          </p>
        </div>

        {!hasQuestions ? (
          <div className='experience-qcopy-empty'>
            <p>No questions to preview</p>
          </div>
        ) : (
          <>
            <div className='experience-qcopy-source'>
              <b>Source Experiences:</b>
              {sourceLabel ? <span>{sourceLabel}</span> : null}
            </div>

            <div className='experience-qcopy-list'>
              {questions.map((question, index) => (
                <div
                  className='experience-qcopy-row'
                  key={question._id || index}>
                  <span className='experience-qcopy-label'>
                    Question {index + 1}:
                  </span>
                  <span className='experience-qcopy-text'>
                    {question.text || 'Untitled question'}
                  </span>
                </div>
              ))}
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer className='experience-qcopy-footer'>
        <div className='experience-modal-actions'>
          <button
            type='button'
            className='btn-outline-experience'
            onClick={handleCancel}
            disabled={isLoading}>
            Cancel
          </button>
          <button
            type='button'
            className='btn-navy'
            onClick={handleConfirm}
            disabled={isLoading || !hasQuestions}>
            {isLoading ? 'Copying…' : 'Copy questions'}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

QuestionCopyPreviewModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setShowModal: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  questions: PropTypes.array,
  selectedQuest: PropTypes.object,
  isLoading: PropTypes.bool,
  onClear: PropTypes.func,
}

QuestionCopyPreviewModal.defaultProps = {
  questions: [],
  selectedQuest: null,
  isLoading: false,
  onCancel: null,
  onClear: null,
}

export default QuestionCopyPreviewModal
